import { render, staticRenderFns } from "./RewardConfiguration.vue?vue&type=template&id=47655afe&"
import script from "./RewardConfiguration.vue?vue&type=script&lang=js&"
export * from "./RewardConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47655afe')) {
      api.createRecord('47655afe', component.options)
    } else {
      api.reload('47655afe', component.options)
    }
    module.hot.accept("./RewardConfiguration.vue?vue&type=template&id=47655afe&", function () {
      api.rerender('47655afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/reward/RewardConfiguration.vue"
export default component.exports